import {Button, Input, Typography, Dropdown} from 'antd';

const {Text} = Typography;
const SearchAndCartSection = ({
  searchValue,
  handleSearchChange,
  cartItemQuantity,
  toggleCartScreen,
  clearCart,
}) => {
  const cartIcon = cartItemQuantity > 0 ? '/cartIcon.svg' : '/cartIconGrey.svg';
  return (
    <div
      style={{
        padding: '10px',
        height: '5%',
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      <Input
        placeholder="Search"
        value={searchValue}
        onChange={handleSearchChange}
        style={{
          width: '75%',
          fontSize: '18px',
          background: '#F8F9FA',
          border: 'none',
        }}
        prefix={
          <img width={16} height={16} src={'/searchIcon.svg'} alt="search" />
        }
      />
      <Button
        onClick={toggleCartScreen}
        style={{
          backgroundColor: cartItemQuantity === 0 ? '#F1F3F5' : '#369eff',
          padding: '8px 10px',
          border: 'none',
          position: 'relative',
        }}
      >
        <img width={16} height={16} src={cartIcon} alt="cart" />
        {cartItemQuantity > 0 && (
          <div
            style={{
              position: 'absolute',
              top: '-5px',
              right: '-5px',
              backgroundColor: '#FF0000',
              borderRadius: '50%',
              width: '20px',
              height: '20px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              color: '#fff',
              fontSize: '12px',
              fontWeight: '600',
            }}
          >
            {cartItemQuantity}
          </div>
        )}
      </Button>
      <Dropdown
        menu={{
          items: [
            {
              label: <Text>Clear Cart</Text>,
              key: '1',
              onClick: () => clearCart(),
            },
          ],
        }}
        placement="bottom"
      >
        <Button
          onClick={e => {
            e.stopPropagation();
          }}
          ghost
          style={{
            height: 22,
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 0,
            border: 'none',
          }}
          icon={
            <img src={'/threeDots.svg'} width={16} height={4} alt="threeDots" />
          }
        />
      </Dropdown>
    </div>
  );
};

export default SearchAndCartSection;
